import { defineComponent as t, createBlock as r, openBlock as l, unref as i, mergeProps as c, withCtx as a, createElementVNode as p } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconLocationPinFilled",
  __name: "IconLocationPinFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (m, e) => (l(), r(i(d), c(n, { "view-box": "0 0 24 24" }), {
      default: a(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M4.25 10.298c0-4.218 3.409-7.95 7.75-7.95s7.75 3.732 7.75 7.95c0 1.033-.387 2.152-.922 3.222-.541 1.084-1.27 2.188-2.029 3.21-1.519 2.046-3.211 3.827-3.923 4.552a1.223 1.223 0 0 1-1.752 0C10.412 20.557 8.72 18.776 7.2 16.73c-.76-1.022-1.488-2.126-2.029-3.21-.535-1.07-.922-2.189-.922-3.222m6.513-1.437a1.75 1.75 0 1 1 2.474 2.475 1.75 1.75 0 0 1-2.474-2.475",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
